import { makeStyles } from "@material-ui/core";

const HEADER_HEIGHT = 44;
const COOKIEBAR_HEIGHT = 46;

const useStyles = makeStyles((theme) => ({
  content: {
    position: "relative",
    display: "flex",
    width: "100%",
    "&$fullHeight": {
      height: `calc(100vh - ${HEADER_HEIGHT}px)`,
      "&$cookieBar": {
        height: `calc(100vh - ${HEADER_HEIGHT}px - ${COOKIEBAR_HEIGHT}px)`,
      },
    },
  },
  fullHeight: {},
  cookieBar: {},
  kpi: {
    height: 138,
    [theme.breakpoints.down("sm")]: {
      height: 116,
    },
  },
  container: {
    position: "absolute",
    top: theme.hvSpacing(2),
    [theme.breakpoints.up("md")]: {
      top: theme.hvSpacing(4),
    },
  },
  topMargin: {
    marginTop: HEADER_HEIGHT,
  },
}));

export default useStyles;
